import { SUPPLIER_ROLES, PERMISSIONS } from 'constants/all';

import { getIsQuoteReadOnly } from 'store/quotes/selectors';
import { getGroupMemberSupplierRoles } from 'store/session/selectors';

export const isUserReadOnly = (state) =>
  getGroupMemberSupplierRoles(state)[SUPPLIER_ROLES.QUOTES] ===
  PERMISSIONS.READ_ONLY;

export const isUserDraft = (state) =>
  getGroupMemberSupplierRoles(state)[SUPPLIER_ROLES.QUOTES] ===
  PERMISSIONS.DRAFT;

export const isQuoteReadOnly = (state) =>
  getIsQuoteReadOnly(state) || isUserReadOnly(state);
